"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.improvementProvider = exports.documentImprovements = void 0;
exports.documentImprovements = [
    {
        document_improvement_guid: "joiwnv-238490hnfiw4",
        code: "S5",
        description: "Inappropriate use of other author document",
        provider_query: true,
        document_status: "OPEN",
        deleted: "false",
        created_date: "2023-07-25 11:52:50.710",
        updated_date: "2023-07-25 11:55:50.710",
        providers: [
            {
                provider_guid: "p123",
                provider_number: "p123",
                provider_name: "P1",
                provider_query_status: "RESOLVED",
                deleted: false
            },
            {
                provider_guid: "p1234",
                provider_number: "p1234",
                provider_name: "P2",
                provider_query_status: "OPEN",
                deleted: false
            },
            {
                provider_guid: "p12345",
                provider_number: "p1235",
                provider_name: "P3",
                provider_query_status: "INCOMPLETE",
                deleted: false
            }
        ],
        charge_code: null,
        potential_charge_code: null
    },
    {
        document_improvement_guid: "58941aeb-6931-4afb-8c97-a397780811c3",
        code: "A34",
        description: "Layout and formatting improvements",
        provider_query: true,
        document_status: "RESOLVED",
        deleted: "false",
        created_date: "2023-06-25 11:52:50.710",
        updated_date: "2023-07-25 11:55:50.710",
        providers: [],
        charge_code: "123",
        potential_charge_code: "124"
    },
    {
        document_improvement_guid: "joiwnv-238490hnfiwdf2",
        code: "S6",
        description: "Inappropriate use of other author document",
        provider_query: false,
        document_status: "OPEN",
        deleted: "false",
        created_date: "2023-07-26 11:52:50.710",
        updated_date: "2023-07-25 11:55:50.710",
        providers: [
            {
                provider_guid: "p123",
                provider_number: "p123",
                provider_name: "P1",
                provider_query_status: "RESOLVED",
                deleted: false
            },
            {
                provider_guid: "p1234",
                provider_number: "p1234",
                provider_name: "P2",
                provider_query_status: "OPEN",
                deleted: false
            },
            {
                provider_guid: "p12345",
                provider_number: "p1235",
                provider_name: "P3",
                provider_query_status: "INCOMPLETE",
                deleted: false
            }
        ],
        charge_code: null,
        potential_charge_code: null
    },
    {
        document_improvement_guid: "joiwnv-238490hnfiwdf1",
        code: "S6",
        description: "Inappropriate use of other author document",
        provider_query: false,
        document_status: "OPEN",
        deleted: "false",
        created_date: "2023-07-26 11:42:50.710",
        updated_date: "2023-07-25 11:55:50.710",
        providers: [],
        charge_code: null,
        potential_charge_code: null
    }
];
exports.improvementProvider = {
    provider_guid: "p123",
    provider_number: "p123",
    provider_name: "P1",
    provider_query_status: "RESOLVED",
    deleted: false
};
//# sourceMappingURL=document-improvements.js.map